import { mapActions, mapMutations, mapGetters } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { mask } from 'vue-the-mask'

import SagahHeader from '@/components/header'
import SagahFooter from '@/components/footer'
import MaintainerPeriods from '@/components/modals/maintainerPeriods'
import ClientList from '@/components/modals/clientList'
import ConfirmModal from '@/components/modals/confirmModal'
import MenuSidebar from '@/components/menuSidebar'
import powerbi from '@/components/modals/powerbi'
import HandleDateMixin from '@/mixin/handleDate'

import moment from 'moment'

export default {
  directives: { mask },
  mixins: [HandleDateMixin],
  components: {
    SagahHeader,
    SagahFooter,
    MaintainerPeriods,
    ClientList,
    ConfirmModal,
    MenuSidebar,
    powerbi
  },
  data () {
    return {
      showModalPowerbi: false,
      nameSalesforceModal: '',
      isMiniMenu: true,
      isConfirmModalOpen: false,
      maintainerIdForClientModal: null,
      maintainersSearch: '',
      maintainersPage: 1,
      totalPages: 0,
      maintainersSortType: 'asc',
      maintainersSortOptions: [
        {
          text: 'Ordem alfabética crescente',
          value: 'asc'
        },
        {
          text: 'Ordem alfabética decrescente',
          value: 'desc'
        }
      ],
      selectedRowsPerPage: 10,
      itemsPerPageOptions: [10, 15, 20, 40],
      selectedMaintainer: {
        active: true,
        cnpj: null,
        codmaintainer: null,
        id: 0,
        idcontractstage: 0,
        idmodelcontract: 0,
        idsalesforce: null,
        idhubspot: null,
        namebilling: null,
        namesalesforce: null,
        nametypeform: null,
        tenant_alias: null,
        integrationdate: null
      },
      integrationDateErrorMessage: '',
      isIntegrationDateError: false,
      isLoadingMaintainers: false,
      isPeriodDialogOpen: false,
      isClientsDialogOpen: false,
      isContractModelsLoading: false,
      isContractStagesLoading: false,
      isRegisterButtonLoading: false,
      isTableLoading: false
    }
  },
  mounted () {
    this.clearFields()
    this.isContractModelsLoading = true
    this.isContractStagesLoading = true
    this.CLEAR_SELECTED_MAINTAINER()
    this.CLEAR_REGISTRATION_TYPES()
    this.CLEAR_SELECTED_MAINTAINER_PERIODS()
    this.getMaintainers()
  },
  computed: {
    ...mapGetters([
      'getterMaintainers',
      'getterSelectedMaintainer',
      'getterContractModels',
      'getterContractStages'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_MAINTAINERS',
      'CLEAR_MAINTAINERS',
      'ADD_NEW_MAINTAINER',
      'UPDATE_MAINTAINER',
      'REMOVE_MAINTAINER',
      'SET_SELECTED_MAINTAINER',
      'CLEAR_SELECTED_MAINTAINER',
      'CLEAR_REGISTRATION_TYPES',
      'CLEAR_SELECTED_MAINTAINER_PERIODS'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    ...mapActions([
      'actionGetMaintainers',
      'actionGetOneMaintainer',
      'actionRegisterMaintainer',
      'actionGetContractModels',
      'actionGetContractStages',
      'actionUpdateMaintainer',
      'actionDeleteMaintainer',
      'actionGetMaintainerPeriods'
    ]),
    openModalPowerBi (nameSalesforce) {
      this.nameSalesforceModal = nameSalesforce

      this.showModalPowerbi = true
    },
    closeModalPowerBi () {
      this.nameSalesforceModal = ''

      this.showModalPowerbi = false
    },
    editMaintainer (maintainer) {
      this.$refs.inputFocus.focus()

      Object.assign(this.selectedMaintainer, maintainer)
      this.selectedMaintainer.integrationdate = this.selectedMaintainer.integrationdate
        ? moment(this.selectedMaintainer.integrationdate).utc().format('DD/MM/YYYY')
        : ''

      this.SET_SELECTED_MAINTAINER(maintainer)
    },
    openMaintainerPeriodManagement (item) {
      this.isTableLoading = true

      this.SET_SELECTED_MAINTAINER(item)

      this.actionGetMaintainerPeriods(item.id)
        .then(() => {
          this.isPeriodDialogOpen = true
          this.isTableLoading = false
          document.querySelector('body').classList.add('overflow-y-hidden')
        })
        .catch(() => {
          this.isTableLoading = false
        })
    },
    getMaintainers (resetPage = false) {
      this.isLoadingMaintainers = true
      this.maintainersPage = resetPage ? 1 : this.maintainersPage
      this.CLEAR_MAINTAINERS()

      const params = {
        search: this.maintainersSearch || '',
        page: this.maintainersPage,
        sortDirection: this.maintainersSortType,
        rowsPerPage: this.selectedRowsPerPage
      }

      this.actionGetMaintainers(params)
        .then((response) => {
          this.SET_MAINTAINERS(response)
          this.totalPages = (Math.ceil(parseInt(this.getterMaintainers.total.count) / this.selectedRowsPerPage))
          this.getContractModels()

          this.isLoadingMaintainers = false
        })
        .catch((e) => {
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })

          this.isLoadingMaintainers = false
        })
    },
    clearSearch () {
      this.maintainersSearch = ''
      this.getMaintainers(true)
    },
    increasePage () {
      this.maintainersPage += 1
      this.getMaintainers()
    },
    decreasePage () {
      this.maintainersPage -= 1
      this.getMaintainers()
    },
    changeRowsPerPage (rows) {
      this.maintainersPage = 1
      this.selectedRowsPerPage = rows
      this.getMaintainers(true)
    },
    getContractModels () {
      this.isContractModelsLoading = true

      this.actionGetContractModels()
        .then(() => {
          this.isContractModelsLoading = false

          this.getContractStages()
        })
        .catch((e) => {
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })

          this.isContractModelsLoading = false
        })
    },
    getContractStages () {
      this.isContractStagesLoading = true

      this.actionGetContractStages()
        .then(() => {
          this.isContractStagesLoading = false
        })
        .catch((e) => {
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })

          this.isContractStagesLoading = false
        })
    },
    registerMaintainer () {
      const [day, month, year] = this.separateDateElements(this.selectedMaintainer.integrationdate)

      if (parseInt(day) > 31 || parseInt(month) > 12) {
        this.isIntegrationDateError = true

        this.integrationDateErrorMessage = 'A data informada é inválida'
      } else if (this.selectedMaintainer.tenant_alias && !this.selectedMaintainer.integrationdate) {
        this.isIntegrationDateError = true

        this.integrationDateErrorMessage = 'É obrigatório informar a data de integração'
      } else {
        this.resetIntegrationDateError()
        this.isRegisterButtonLoading = true

        const dateFormatted = moment(new Date(year, (month - 1), day)).utc().format('YYYY-MM-DD')

        const params = {
          idModelContract: this.selectedMaintainer.idmodelcontract,
          idContractStage: this.selectedMaintainer.idcontractstage,
          idSalesforce: this.selectedMaintainer.idsalesforce,
          nameSalesforce: this.selectedMaintainer.namesalesforce,
          codMaintainer: this.selectedMaintainer.codmaintainer,
          cnpj: this.selectedMaintainer.cnpj,
          idHubSpot: this.selectedMaintainer.idhubspot,
          nameBilling: this.selectedMaintainer.namebilling,
          nameTypeForm: this.selectedMaintainer.nametypeform,
          active: this.selectedMaintainer.active,
          tenantAlias: this.selectedMaintainer.tenant_alias,
          integrationDate: dateFormatted !== 'Invalid date' ? dateFormatted : null
        }

        this.actionRegisterMaintainer(params)
          .then((response) => {
            this.ADD_NEW_MAINTAINER(response)

            this.addToast({
              text: 'Conta cadastrada com sucesso.',
              type: 'success'
            })

            this.clearFields()

            this.isRegisterButtonLoading = false
          })
          .catch((e) => {
            this.addToast({
              text: e.message || e,
              type: 'danger'
            })

            this.isRegisterButtonLoading = false
          })
      }
    },
    updateMaintainer () {
      const [day, month, year] = this.separateDateElements(this.selectedMaintainer.integrationdate)

      if (parseInt(day) > 31 || parseInt(month) > 12) {
        this.isIntegrationDateError = true

        this.integrationDateErrorMessage = 'A data informada é inválida'
      } else if (this.selectedMaintainer.tenant_alias && !this.selectedMaintainer.integrationdate) {
        this.isIntegrationDateError = true

        this.integrationDateErrorMessage = 'É obrigatório informar a data de integração'
      } else {
        this.resetIntegrationDateError()
        this.isRegisterButtonLoading = true
        this.SET_SELECTED_MAINTAINER(this.selectedMaintainer)

        const dateFormatted = moment(new Date(year, (month - 1), day)).utc().format('YYYY-MM-DD')

        const params = {
          id: this.selectedMaintainer.id,
          data: {
            idModelContract: this.selectedMaintainer.idmodelcontract,
            idContractStage: this.selectedMaintainer.idcontractstage,
            idSalesforce: this.selectedMaintainer.idsalesforce,
            nameSalesforce: this.selectedMaintainer.namesalesforce,
            codMaintainer: this.selectedMaintainer.codmaintainer,
            cnpj: this.selectedMaintainer.cnpj,
            idHubSpot: this.selectedMaintainer.idhubspot,
            nameBilling: this.selectedMaintainer.namebilling,
            nameTypeForm: this.selectedMaintainer.nametypeform,
            active: this.selectedMaintainer.active,
            tenantAlias: this.selectedMaintainer.tenant_alias,
            integrationDate: dateFormatted !== 'Invalid date' ? dateFormatted : null
          }
        }

        this.actionUpdateMaintainer(params)
          .then((response) => {
            this.UPDATE_MAINTAINER(response)

            this.addToast({
              text: 'Conta atualizada com sucesso.',
              type: 'success'
            })

            this.clearFields()

            this.isRegisterButtonLoading = false
          })
          .catch((e) => {
            this.addToast({
              text: e.message || e,
              type: 'danger'
            })

            this.isRegisterButtonLoading = false
          })
      }
    },
    deleteMaintainer () {
      this.actionDeleteMaintainer(this.getterSelectedMaintainer.id)
        .then((response) => {
          this.REMOVE_MAINTAINER({ id: this.getterSelectedMaintainer.id })

          this.addToast({
            text: response.message,
            type: 'success'
          })

          this.closeConfirmModal()
        })
        .catch((e) => {
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })

          this.closeConfirmModal()
        })
    },
    validateFields () {
      if (!this.selectedMaintainer.idmodelcontract || !this.selectedMaintainer.idcontractstage || !this.selectedMaintainer.idsalesforce || !this.selectedMaintainer.namesalesforce || !this.selectedMaintainer.codmaintainer || !this.selectedMaintainer.cnpj || !this.selectedMaintainer.namebilling) {
        return true
      }
    },
    clearFields () {
      this.CLEAR_SELECTED_MAINTAINER()
      this.selectedMaintainer = {
        active: true,
        cnpj: '',
        codmaintainer: '',
        id: 0,
        idcontractstage: 0,
        idmodelcontract: 0,
        idsalesforce: '',
        namebilling: '',
        namesalesforce: '',
        nametypeform: '',
        tenant_alias: '',
        integrationdate: ''
      }
    },
    openClientModal (id) {
      this.isTableLoading = true
      this.maintainerIdForClientModal = id
      this.actionGetOneMaintainer(id)
        .then(() => {
          this.isTableLoading = false
          this.isClientsDialogOpen = true
        })
        .catch((e) => {
          this.isTableLoading = false
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })
        })
    },
    openConfirmModal (maintainer) {
      this.SET_SELECTED_MAINTAINER(maintainer)
      this.isConfirmModalOpen = true
    },
    closeConfirmModal () {
      this.CLEAR_SELECTED_MAINTAINER()
      this.isConfirmModalOpen = false
    },
    dateFormatted (date) {
      return moment(date).utc(0).format('DD/MM/YYYY')
    },
    resetIntegrationDateError () {
      this.isIntegrationDateError = false
      this.integrationDateErrorMessage = ''
    }
  }
}
